import {ref, computed} from "vue";
import {defineStore} from 'pinia'
import http from '@/http/http'
import {cancelMonitoring} from "@/util/im";

export const useUserStore = defineStore('userStore', () => {
    const imId = ref('')
    const userId = ref('')
    const userToken = ref('')
    const user = ref({})
    const imReady = ref(false)

    //获取是否已登录
    const isLogin = computed(() => {
        return userToken.value !== ''
    })
    //请求获取用户信息
    const getUserInfo = () => {
        http.post('sys/user/findByUserId').then(res => {
            if (res.code == 200) {
                user.value = res.data
            }
        }).catch(e => {
            console.log(e)
        })
    }
    //退出登录
    const logout = () => {
        imId.value = ''
        userId.value = ''
        userToken.value = ''
        user.value = {}
        imReady.value = false
        cancelMonitoring()
    }
    return {
        imId,
        userId,
        userToken,
        isLogin,
        user,
        imReady,
        getUserInfo,
        logout
    }
}, {
    persist: {
        // storage: sessionStorage,
        key: 'my-app-user', // 存储键名
        pick: ['imId', 'userId', 'userToken', 'user'], // 移除 imReady，避免持久化导致 chat 实例丢失后状态不一致
    }
})
